module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_41.34b82e8c.jpg";